import { Link } from "react-router-dom";
import CaseCard from "@/components/feature/CaseCard";
import SectionTitle from "@/components/base/SectionTitle";
import { caseArticles } from "@/mocks/cases";

export default function HotCasesSection() {
  const featured = caseArticles.filter((item) => item.featured);
  const lead = featured[0];
  const rest = featured.slice(1);
  const others = caseArticles.filter((item) => !item.featured).slice(0, 2);

  return (
    <section id="hot-cases" className="w-full bg-background-100 py-14 md:py-20 scroll-mt-[72px]">
      <div className="max-w-content mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-5">
          <SectionTitle
            eyebrow="Featured Cases"
            title="重点调查档案"
            description="从动机、产业链到法律边界，每一份档案都试图回答一个具体的问题，而不是再制造一次愤怒。"
          />
          <Link
            to="/cases"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer transition-colors bg-background-50 border border-background-300 text-foreground-800 hover:border-primary-400 hover:text-primary-600 shrink-0"
          >
            查看全部档案
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </Link>
        </div>

        <div className="mt-8 md:mt-10 grid grid-cols-1 lg:grid-cols-12 gap-5 md:gap-6">
          <div className="lg:col-span-7">
            <CaseCard article={lead} variant="wide" />
          </div>
          <div className="lg:col-span-5 flex flex-col gap-4">
            {rest.map((item) => (
              <CaseCard key={item.slug} article={item} variant="compact" />
            ))}
            {others.map((item) => (
              <CaseCard key={item.slug} article={item} variant="compact" />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}